import { twMerge } from "tailwind-merge"
const Heading1: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h1
      className={twMerge(
        `
          font-bricolage text-[3rem] md:text-[3.5rem] 
          leading-[120%] md:leading-[100%] 
          
          mb-[1.5rem]
        `,
        className,
      )}
      {...props}>
      {children}
    </h1>
  )
}

export default Heading1
